import React from "react";
import { Notification, NotificationBaseProps } from "Views/Shared/Notification";

export function PolicyRenewalNoLongerAvailableNotification(
  props: NotificationBaseProps & {
    PolicyType: string;
    ApplicantFullName: string;
    Link: string;
  },
) {
  return (
    <Notification {...props} Heading="Policy Renewal No Longer Available">
      The link to renew {props.PolicyType} Insurance coverage for{" "}
      {props.ApplicantFullName} has expired. To apply for a new policy, please{" "}
      <a href={props.Link}>click here</a>.
    </Notification>
  );
}
